module.exports = __webpack_public_path__ + "ae160cc389ef629683994596b5593b3c.svg";